















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { OutgoingInvoiceEditModel, OutgoingInvoiceStatusEnum, TimeEntryFilter, TimeEntryFilterTimeFrame } from '@/services/api/nswag/stapiclient_generated';
import { outgoingInvoiceApi } from '@/services/st-api';
import { notifySuccess } from '@/utlitities/notifications';
import StBadge from '@/components/basic/StBadge.vue';

@Component({
  components: {
    StBadge,
  },
})
export default class OutgoingInvoiceEmail extends Vue {
  @Prop() value!: OutgoingInvoiceEditModel;
  saveLoading = false;
  sendLoading = false;

  get editModel() {
    return this.value;
  }

  set editModel(data: OutgoingInvoiceEditModel) {
    this.$emit('input', data);
  }

  get isSent() {
    return this.editModel.currentStatus?.status == OutgoingInvoiceStatusEnum.Sent;
  }

  get statusDate() {
    return this.editModel.currentStatus?.statusDate;
  }

  get statusString() {
    return this.$t(this.editModel.currentStatus?.statusTranslationString ?? '');
  }

  get contactNamePlaceholder(){
    if (this.editModel.contactNamePlaceholder && (this.editModel.emailText?.indexOf('{Ansprechpartner}') ?? -1) > -1) {
      return this.editModel.contactNamePlaceholder;
    }
  }

  get dateFromPlaceholder() {
    if (this.editModel.dateFromPlaceholder && (this.editModel.emailText?.indexOf('{DatumVon}') ?? -1) > -1) {
      return this.editModel.dateFromPlaceholder;
    }
  }

  get dateToPlaceholder() {
    if (this.editModel.dateToPlaceholder && (this.editModel.emailText?.indexOf('{DatumBis}') ?? -1) > -1) {
      return this.editModel.dateToPlaceholder;
    }
  }

  async save() {
    if (this.editModel.filterJson) {
      let filter = TimeEntryFilter.fromJS(JSON.parse(this.editModel.filterJson!));

      filter.timeframe = TimeEntryFilterTimeFrame.Custom;
      this.editModel.filterJson = JSON.stringify(filter);
    }

    if (this.editModel.id == 0) {
      this.editModel.id = await outgoingInvoiceApi.post(this.editModel);
    } else {
      await outgoingInvoiceApi.put(this.editModel);
    }
  }

async send(){
  try{
    this.sendLoading = true;
    await this.save();
    await outgoingInvoiceApi.sendEmail(this.editModel.id!);
    notifySuccess('E-Mail versendet');
    this.$emit('reloadStatus');
  }finally {
    this.sendLoading = false;
  }
}

  async submit() {
    try {
      this.saveLoading = true;

      await this.save();
    } finally {
      this.saveLoading = false;
    }

    notifySuccess('Erfolgreich gespeichert');
  }
}
